export default __webpack_public_path__ + "static/media/editor-underline-btn-icon.789b1894.svg";